// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const workspaceSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  name: z.string().max(500),
  title: z.string().max(500),
  description: z.string().max(100000),
  tags: z.array(z.string()).optional(),
  status: z.string().max(50),
  archivedAt: z.string().max(200).datetime().optional(),
  archived: z.boolean(),
  icon: z.string().max(50).optional(),
  color: z.string().max(20).optional(),
  tenantId: z.string().max(100).optional(),
})

export type WorkspaceInput = z.infer<typeof workspaceSchema>
